import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { api } from '../../../environments/api';
import { catchError, map, tap } from 'rxjs/operators';
import { UserAccount, UserAccountData, UserLoginResponse } from '../../views/bean/UserAccount';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  formDataHttpOptions = {
    headers: new HttpHeaders({ 'Content-Type': undefined })
  }

  constructor(private http: HttpClient) { }

  login(data: any): Observable<UserLoginResponse> {
    return this.http.post<UserLoginResponse>(api.login, data, this.httpOptions);
  }

}
